import {Badge, Box, Stack, Tooltip, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {HeatZone} from '@kilnfeature/types'

type HeatZoneSectionProps = {
  heatZone: HeatZone
  index: number
  width: number
  zoneHeight?: number
  hideDetails?: boolean
}

const BREAKPOINT_TEXT_HIDDEN = 120
const DEFAULT_ZONE_HEIGHT = 72

export const HeatZoneSection = ({
  heatZone,
  width,
  index,
  zoneHeight,
  hideDetails
}: HeatZoneSectionProps) => {
  const {t} = useTranslation()
  const translatedName = t(`heatZones.zones.${heatZone.name}`, heatZone.name)

  return (
    <Tooltip
      title={
        <Box>
          <Typography>{translatedName}</Typography>
          <Typography>
            {heatZone.start} - {heatZone.end} meters
          </Typography>
        </Box>
      }
    >
      <Box
        width={width}
        sx={{background: index & 1 ? '#52667A' : '#8599AD', cursor: 'pointer'}}
        height={`${zoneHeight ?? DEFAULT_ZONE_HEIGHT}px`}
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={1}
        overflow="hidden"
      >
        <Stack alignItems="center">
          <Stack direction="row" gap={2}>
            {!hideDetails && (
              <Box mb={0.5}>
                <Badge color="secondary" badgeContent={index + 1} />
              </Box>
            )}
            {width > BREAKPOINT_TEXT_HIDDEN && (
              <Box overflow="hidden" maxWidth={width - 60}>
                <Typography
                  data-cy="heat_zone_name"
                  color="#FFF"
                  lineHeight="25px"
                  variant="h5"
                  noWrap
                >
                  {translatedName}
                </Typography>
              </Box>
            )}
          </Stack>
          {width > BREAKPOINT_TEXT_HIDDEN && !hideDetails && (
            <Box>
              <Typography noWrap variant="subtitle2" color="rgba(255, 255, 255, 0.6)">
                {heatZone.start} - {heatZone.end}
              </Typography>
            </Box>
          )}
        </Stack>
      </Box>
    </Tooltip>
  )
}
